// eslint-disable-next-line import/no-relative-packages
import { GenerationDataPoints } from '../../../../../universal-dashboard-api/src/Data-Processor/Entities/Interfaces/GenerationBreakdownDAO';
import { NON_HYDRO_RENEWABLES, HYDRO_FUEL_TYPES } from './const';

export function filterOnlyRenewableGeneration(
  data: GenerationDataPoints[],
): GenerationDataPoints[] {
  const nonHydroRenewables = data.filter(({ fuelType }) =>
    NON_HYDRO_RENEWABLES.includes(fuelType),
  );

  const hydroRenewables = data
    .filter(({ fuelType }) => HYDRO_FUEL_TYPES.includes(fuelType))
    .reduce(
      (acc, curr) => ({
        ...acc,
        generation: acc.generation + curr.generation,
      }),
      { fuelType: 'HYDRO', generation: 0 },
    );
  return [...nonHydroRenewables, hydroRenewables];
}
